import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormlyFieldDate } from './date.type';
import { FormlyFormFieldModule } from '../form-field/public_api';

@NgModule({
    declarations: [FormlyFieldDate],
    imports: [
        CommonModule,
        DateInputsModule,
        ReactiveFormsModule,

        FormlyFormFieldModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'kendo-date',
                    component: FormlyFieldDate,
                    wrappers: ['kendo-form-field'],
                    defaultOptions: {
                        props: {
                            nullable: false
                        },
                    },
                },
                {
                    name: 'kendo-date-time',
                    extends: 'kendo-date'
                },
                {
                    name: 'kendo-month-date',
                    extends: 'kendo-date'
                },
                {
                    name: 'kendo-year-date',
                    extends: 'kendo-date'
                }
            ],
        }),
    ],
})
export class FormlyDateModule { }
